// extracted by mini-css-extract-plugin
export default {"container":"aS-z","leftColumn":"bS-z","rightColumn":"cS-z","item":"dS-z"};